import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class AccountGroupMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      accountGroupList: [],
      accountGroupDetails: {
        accountGroupname: "",
        accountGroupType: "",
      },
    };
  }

  componentDidMount() {
    this.getAllAccountGroups();
  }

  getAllAccountGroups = () => {
    this.commonServices.getAllAccountGroups().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ accountGroupList: response.responseData });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditAccountGroup = () => {
    if (
      this.state.accountGroupDetails.accountGroupname !== "" &&
      this.state.accountGroupDetails.accountGroupType !== ""
    ) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.accountGroupDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditAccountGroup(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.resetForm();
            this.setState({ isLoading: false })
            this.SwalServices.Success(response.Message);
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: false })
          }
        });
      });
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
      this.setState({ isLoading: false })
    }
  };

  resetForm = () => {
    let details = this.state.accountGroupDetails;
    details.accountGroupname = "";
    details.accountGroupType = "";
    this.setState({ accountGroupDetails: details }, () => {
      this.setState({ _id: "", isEditing: false }, () => {
        console.log(this.state._id);
        this.getAllAccountGroups();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.accountGroupDetails;
    details[name] = value.toUpperCase();
    this.setState({ accountGroupDetails: details });
  };

  getAccountDetailsById = (group) => {
    let details = this.state.accountGroupDetails;
    details.accountGroupname = group.accountGroupname;
    details.accountGroupType = group.accountGroupType;
    this.setState({ accountGroupDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteAccountGroupById = (id) => {
    this.itemMasterServices.deleteAccountGroupById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllAccountGroups();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  handleRadioButtonChange = (event) => {
    let value = event.target.value;
    let details = this.state.accountGroupDetails;
    details.accountGroupType = value;
    this.setState({ accountGroupDetails: details });
  };

  render() {
    return (
      <div className="accGrpMaster-page">
        <div className="item-search mb-4">
          <div className="item-grp">
            <div className="item-search-box w-[50%]">
              <label>A/c Group Name</label>
              <input
                className="inputFocus"
                type="text"
                id="accountGroupname"
                name="accountGroupname"
                autoComplete="off"
                value={this.state.accountGroupDetails.accountGroupname}
                onChange={(event) =>
                  this.handleChange(event, "accountGroupname")
                }
              />
            </div>
            <div className="account-effects !mt-2 mb-2">
              <span style={{ fontSize: "16.3px", fontWeight: "600" }}>
                Final Account Effects
              </span>
              <div className="input-grp mb-3 mt-1.5 w-fit">
                <label>
                  <input
                    className="inputFocus mr-1  w-fit"
                    type="radio"
                    name="accountGroup"
                    id="Balance Sheet"
                    value="Balance Sheet"
                    checked={
                      this.state.accountGroupDetails.accountGroupType ===
                      "Balance Sheet"
                    }
                    onChange={(event) => this.handleRadioButtonChange(event)}
                  />
                  Balance Sheet
                </label>

                <label>
                  <input
                    className="inputFocus mr-1  w-fit"
                    type="radio"
                    name="accountGroup"
                    id="Trading Account"
                    value="Trading Account"
                    checked={
                      this.state.accountGroupDetails.accountGroupType ===
                      "Trading Account"
                    }
                    onChange={(event) => this.handleRadioButtonChange(event)}
                  />
                  Trading Account
                </label>

                <label>
                  <input
                    className="inputFocus mr-1  w-fit"
                    type="radio"
                    name="accountGroup"
                    id="Profit and Loss Statement"
                    value="Profit and Loss Statement"
                    checked={
                      this.state.accountGroupDetails.accountGroupType ===
                      "Profit and Loss Statement"
                    }
                    onChange={(event) => this.handleRadioButtonChange(event)}
                  />
                  Profit and Loss Statement
                </label>
              </div>
            </div>
          </div>
          <div className="btn-grp">
            {this.state.isEditing === true ? (
              <button
                className="add-btn"
                disabled={this.state.isLoading}
                onClick={() => this.addEditAccountGroup()}
              >
                {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
              </button>
            ) : (
              <button
                className="add-btn"
                disabled={this.state.isLoading}
                onClick={() => this.addEditAccountGroup()}
              >
                {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
              </button>
            )}
            <button className="cancel-btn"
              disabled={this.state.isLoading}
              onClick={() => this.closeGridView()}>
              Cancel
            </button>
          </div>

        </div>
        <div className="itemList-table">
          <div className="table-container" style={{ height: "calc(100vh - 290px)" }}>
            <table className="itemList">
              <thead>
                <tr>
                  <td className="w-[45%]">A/c Group Name</td>
                  <td className="w-[40%]">Account Effects</td>
                  <td className="w-[15%] !text-center">Action</td>
                </tr>
              </thead>
              <tbody>
                {this.state.accountGroupList &&
                  this.state.accountGroupList.length > 0 &&
                  this.state.accountGroupList.map((group, key) => (
                    <tr key={key}>
                      <td>{group.accountGroupname}</td>
                      <td>{group.accountGroupType}</td>
                      <td style={{ textAlign: 'center' }}>
                        <button
                          className="search-btn"
                          onClick={() => this.getAccountDetailsById(group)}
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </button>
                        <button
                          className="cancel-btn"
                          onClick={() => this.deleteAccountGroupById(group._id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountGroupMaster;
